export default (string) => {
  if (window.s1 && window.s1.wpDataStack && window.s1.wpDataStack.translations) {
    const { translations } = window.s1.wpDataStack;
    const translation = translations.find((t) => t.name.toLowerCase() === string.toLowerCase());
    if (translation) {
      // eslint-disable-next-line no-param-reassign
      string = translation.string;
    }
  }

  return string;
};
